<template>
  <div
    class="expense-card"
    :class="{ 'expense-card--active': expense.isCovered }"
  >
    <div class="expense-card__header">
      <span class="expense-card__label">{{ label }}</span>
      <label class="expense-card__toggle" :class="{ 'is-disabled': disabled }">
        <input
          type="checkbox"
          :checked="expense.isCovered"
          :disabled="disabled"
          @change="$emit('toggle', $event.target.checked)"
        />
        <span class="expense-card__toggle-slider"></span>
      </label>
    </div>

    <div v-if="expense.isCovered && hasLimitOption" class="expense-card__body">
      <span class="checkbox--filter mb-4">
        <input
          :id="`nolimit-${expense.expenseType}`"
          type="checkbox"
          :checked="hasNoLimit"
          :disabled="disabled"
          @change="$emit('toggle-no-limit', $event.target.checked)"
        />
        <label
          class="mb-0 checkbox--filter--label u-weight--normal"
          :for="`nolimit-${expense.expenseType}`"
        >
          {{ $t("ReservationForm.noLimit") }}
        </label>
      </span>

      <div v-if="!hasNoLimit" class="expense-card__fields">
        <div class="expense-card__field">
          <label class="expense-card__field-label">
            {{ $t("ReservationForm.maxPrice") }}
          </label>
          <div class="expense-card__input-wrap">
            <span class="expense-card__currency">&euro;</span>
            <input
              type="text"
              class="expense-card__input"
              :value="expense.maxDailyCosts || ''"
              :placeholder="$t('ReservationForm.pricePlaceholder')"
              :disabled="disabled"
              @input="$emit('price-input', $event.target.value)"
            />
          </div>
        </div>

        <div v-if="hasQuantityOption" class="expense-card__field">
          <label class="expense-card__field-label">
            {{ $t("ReservationForm.amount") }}
          </label>
          <input
            type="text"
            class="expense-card__input"
            :value="expense.maxDailyQuantity || ''"
            :placeholder="$t('ReservationForm.amountPlaceholder')"
            :disabled="disabled"
            @input="$emit('quantity-input', $event.target.value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpenseCard",
  props: {
    expense: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasLimitOption: {
      type: Boolean,
      default: false
    },
    hasQuantityOption: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle", "toggle-no-limit", "price-input", "quantity-input"],
  computed: {
    hasNoLimit() {
      return (
        this.expense.maxDailyCosts === null &&
        this.expense.maxDailyQuantity === null
      );
    }
  }
};
</script>
